/**
 * VideoContent - 视频内容渲染组件
 */

import React from 'react';
import { getProxyUrl } from '../../utils/urlProxy';
import { LazyVideo } from '../common/LazyMedia';

export default function VideoContent({ data, priority = false }) {
  if (!data || !data.video) return null;

  const videoUrl = typeof data.video === 'string' ? data.video : data.video.url;
  const posterUrl = data.poster ? getProxyUrl(data.poster) : null;
  // 使用代理URL避免CORS问题
  const proxyVideoUrl = getProxyUrl(videoUrl);

  return (
    <div className="label-content-video">
      <LazyVideo
        src={proxyVideoUrl}
        poster={posterUrl}
        controls
        className="video-player"
        priority={priority} // 视频默认懒加载，除非明确指定优先级
        onLoad={() => {
          console.log('视频元数据加载完成');
        }}
      />
    </div>
  );
}

